// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27gray%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomSelect_selectContainer__N1cHa {
  position: relative;
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
  color: rgba(115, 115, 115, 1);
}

/* Выбранный элемент */
.CustomSelect_selected__JHAXw {
  position: relative;
  padding: 10px 12px;
  border: 1px solid rgba(203, 213, 225, 1);
  border-radius: 6px;
  background: white;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Кастомная стрелочка */
.CustomSelect_selected__JHAXw::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  height: 8px;
  width: 16px;
  background-repeat: no-repeat;
  background-size: 13.5px 7.5px;
  pointer-events: none;
}

/* Список опций */
.CustomSelect_options__hhVq1 {
  position: absolute;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  max-height: 200px;
  overflow-y: auto;
}

/* Открытие вниз */
.CustomSelect_openDown__pTNDb {
  top: 100%;
  margin-top: 4px;
}

/* Открытие вверх */
.CustomSelect_openUp__jOaIz {
  bottom: 100%;
  margin-bottom: 4px;
}

/* Отдельная опция */
.CustomSelect_option__xLSBl {
  text-align: left;
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.CustomSelect_option__xLSBl:hover {
  background: #f5f5f5;
}

/* Для стрелки, если ты решишь использовать rotate вместо картинки */
.CustomSelect_arrow__GXXdP {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-left: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: transform 0.2s ease;
}

.CustomSelect_arrowOpen__cdEYx {
  transform: rotate(180deg);
}

`, "",{"version":3,"sources":["webpack://./src/styles/CustomSelect.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yDAAuP;EACvP,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".selectContainer {\n  position: relative;\n  font-size: 14px;\n  user-select: none;\n  color: rgba(115, 115, 115, 1);\n}\n\n/* Выбранный элемент */\n.selected {\n  position: relative;\n  padding: 10px 12px;\n  border: 1px solid rgba(203, 213, 225, 1);\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Кастомная стрелочка */\n.selected::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  height: 8px;\n  width: 16px;\n  background-repeat: no-repeat;\n  background-size: 13.5px 7.5px;\n  pointer-events: none;\n}\n\n/* Список опций */\n.options {\n  position: absolute;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 9999;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n/* Открытие вниз */\n.openDown {\n  top: 100%;\n  margin-top: 4px;\n}\n\n/* Открытие вверх */\n.openUp {\n  bottom: 100%;\n  margin-bottom: 4px;\n}\n\n/* Отдельная опция */\n.option {\n  text-align: left;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.option:hover {\n  background: #f5f5f5;\n}\n\n/* Для стрелки, если ты решишь использовать rotate вместо картинки */\n.arrow {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-left: 8px;\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' stroke='gray' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  transition: transform 0.2s ease;\n}\n\n.arrowOpen {\n  transform: rotate(180deg);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectContainer": `CustomSelect_selectContainer__N1cHa`,
	"selected": `CustomSelect_selected__JHAXw`,
	"options": `CustomSelect_options__hhVq1`,
	"openDown": `CustomSelect_openDown__pTNDb`,
	"openUp": `CustomSelect_openUp__jOaIz`,
	"option": `CustomSelect_option__xLSBl`,
	"arrow": `CustomSelect_arrow__GXXdP`,
	"arrowOpen": `CustomSelect_arrowOpen__cdEYx`
};
export default ___CSS_LOADER_EXPORT___;
